import Vue from "vue";

Vue.filter('formatRange', function (value) {
    if (!value) return null;
    else if (value <= 1) return `${value} mile`
    else return `${value} miles`;
  });


  Vue.filter('formatPrice', function (value) {
    if (!value) return null;
    let decimal = value.toString().split('.')[1]
    if(!decimal) return `£${value}.00`
    if(decimal.length < 2){
      return `£${value}0`;
    } else {
      return `£${value}`;
    }
  });

  // Vue.filter('formatTime', function (value) {
  //   if (!value) return null;
  //   return value.slice(5);
  // });